import type { NewsArticle } from "@/types/cinema";

export const newsCategories = ["全部", "资讯", "评论", "预告"];

export const news: NewsArticle[] = [
  {
    id: "n01",
    title: "《星际远征》首周票房破 8 亿，国产科幻再迎高光时刻",
    category: "资讯",
    summary:
      "上映首周，《星际远征》以过硬的口碑与精良的视效吸引大量观众走进影院，刷新多项档期纪录。",
    content: [
      "由陈墨白执导的科幻巨制《星际远征》自 10 月 1 日上映以来，票房表现强劲，首周累计突破 8 亿元，成为国庆档最受关注的作品之一。",
      "影片以人类首次载人深空远征为背景，通过极具想象力的世界观与扎实的特效制作，获得了观众与业内的一致好评，多家影评平台评分稳定在 9 分以上。",
      "据了解，影片在 IMAX 与 CINITY 影厅的排片占比持续走高，观众普遍反映大银幕观影体验更能体现影片的恢弘气质。",
    ],
    date: "2026-10-08",
    author: "影讯编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20film%20press%20photo%2C%20deep%20blue%20space%20nebula%20backdrop%20with%20warm%20amber%20light%2C%20epic%20scale%2C%20editorial%20cinematic%20photography&width=800&height=600&seq=cinema-news-01&orientation=landscape",
    tags: ["票房", "科幻", "国庆档"],
  },
  {
    id: "n02",
    title: "水墨动画《长安万里》口碑炸裂：一场视觉与诗意的盛宴",
    category: "评论",
    summary:
      "以盛唐为背景的水墨动画长片《长安万里》凭借独特美学与深厚文本，被观众称为“今年最值得二刷的国产动画”。",
    content: [
      "《长安万里》用近三小时的时间，把观众带回了那个灯火辉煌的盛唐之夜。影片以水墨笔触勾勒出长安城的壮阔与诗意，每一帧都像一幅徐徐展开的卷轴。",
      "不同于追求强节奏的商业动画，本片更愿意让画面与情绪慢慢流淌。少年诗人的追寻、挚友之间的约定，让这部作品在视觉之外有了更动人的情感内核。",
      "有影评人认为，影片在坚持东方审美表达的同时，也完成了对国产动画叙事边界的又一次拓展，值得反复品味。",
    ],
    date: "2026-10-06",
    author: "特约影评人 · 沈知远",
    cover:
      "https://readdy.ai/api/search-image?query=ink%20wash%20painting%20of%20ancient%20chinese%20city%20at%20night%20with%20glowing%20lanterns%2C%20deep%20blue%20sky%20with%20warm%20golden%20highlights%2C%20artistic%20editorial%20photography&width=800&height=600&seq=cinema-news-02&orientation=landscape",
    tags: ["动画", "影评", "国风"],
  },
  {
    id: "n03",
    title: "《深海回响》曝终极预告：深海之下，还有别的“它”",
    category: "预告",
    summary:
      "惊悚悬疑片《深海回响》发布终极预告，幽暗的海沟与无法解释的低频回响，让整支预告悬念拉满。",
    content: [
      "《深海回响》今日发布终极预告，短短两分钟的画面里，深潜队在马里亚纳海沟底遭遇的一切被首次完整呈现。",
      "预告中，深海幽暗的压迫感与若隐若现的神秘回声交织，配合利落的剪辑节奏，将影片的悬疑气质展现得淋漓尽致。",
      "影片已于 10 月 10 日上映，推荐选择杜比影院感受身临其境的深海沉浸体验。",
    ],
    date: "2026-10-09",
    author: "影讯编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20deep%20ocean%20underwater%20scene%20with%20a%20single%20beam%20of%20light%20from%20above%2C%20deep%20blue%20abyss%20atmosphere%2C%20mysterious%20editorial%20photography&width=800&height=600&seq=cinema-news-03&orientation=landscape",
    tags: ["预告", "悬疑", "惊悚"],
  },
  {
    id: "n04",
    title: "国庆档观察：类型百花齐放，观众更愿意为“好故事”买单",
    category: "评论",
    summary:
      "从科幻到动画、从悬疑到剧情，今年国庆档影片类型格外丰富，市场正回归内容为王。",
    content: [
      "今年国庆档最大的特点，是类型的高度多元。科幻、动画、悬疑、剧情、动作各有代表作，观众的选择从未如此丰富。",
      "值得注意的是，几部口碑突出的作品排片占比在档期内持续走高，说明观众的购票决策越来越依赖真实口碑，“内容为王”再次得到验证。",
      "对影院而言，这也意味着排片需要更加灵活，及时把黄金场次让给真正受欢迎的作品。",
    ],
    date: "2026-10-07",
    author: "行业观察 · 陈立",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20audience%20silhouettes%20watching%20a%20bright%20screen%20in%20a%20dark%20theater%2C%20deep%20blue%20ambient%20light%20with%20warm%20orange%20glow%2C%20editorial%20photography&width=800&height=600&seq=cinema-news-04&orientation=landscape",
    tags: ["行业", "档期", "市场"],
  },
  {
    id: "n05",
    title: "《追风者》IMAX 版上线：城市夜景竞速爽感翻倍",
    category: "资讯",
    summary:
      "动作大片《追风者》确认推出 IMAX 版本，高速竞速场面与城市夜景在巨幕上呈现更强烈的临场感。",
    content: [
      "由美国导演 Marcus Reid 执导的《追风者》正在热映，官方宣布影片 IMAX 版本已同步上线各大巨幕影厅。",
      "影片以横跨整座城市的极速追逐为主线，大量实拍竞速镜头配合 IMAX 画幅，让速度感与城市霓虹的视觉冲击成倍放大。",
      "如果你追求纯粹的视听刺激，IMAX 厅会是这部电影的最佳打开方式。",
    ],
    date: "2026-10-11",
    author: "影讯编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=night%20city%20highway%20with%20car%20light%20trails%20and%20motion%20blur%2C%20deep%20blue%20and%20orange%20cinematic%20grade%2C%20dynamic%20editorial%20photography&width=800&height=600&seq=cinema-news-05&orientation=landscape",
    tags: ["动作", "IMAX", "热映"],
  },
  {
    id: "n06",
    title: "《时光代理人》发布主题曲 MV，时光滤镜再掀泪点",
    category: "预告",
    summary:
      "科幻爱情片《时光代理人》公开主题曲 MV，唯美画面搭配细腻旋律，勾起观众对“遗憾”与“重逢”的共鸣。",
    content: [
      "《时光代理人》今日公开主题曲 MV，影片中关于时光与重逢的片段首次成片曝光。",
      "MV 用梦幻的光影与动人的旋律，将“若能回到过去”的遗憾情绪层层递进，让不少观众直呼“还没看电影就先哭了”。",
      "影片将于 10 月 12 日上映，是本月最受期待的科幻爱情作品。",
    ],
    date: "2026-10-10",
    author: "影讯编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=dreamy%20surreal%20scene%20of%20glowing%20clock%20portal%20with%20floating%20light%20particles%2C%20deep%20blue%20with%20warm%20amber%20glow%2C%20romantic%20editorial%20photography&width=800&height=600&seq=cinema-news-06&orientation=landscape",
    tags: ["预告", "爱情", "主题曲"],
  },
  {
    id: "n07",
    title: "《雪山救援》幕后特辑：零下二十度的高海拔实拍有多难",
    category: "资讯",
    summary:
      "片方发布《雪山救援》幕后特辑，揭秘剧组在极端环境中完成高海拔实拍的全过程。",
    content: [
      "《雪山救援》释出幕后特辑，镜头背后的艰苦程度丝毫不亚于影片本身。",
      "为了真实还原高山救援的紧张氛围，剧组在海拔数千米的雪线之上连续拍摄数月，多位演员亲自完成高强度动作戏份。",
      "影片已于 10 月 18 日登陆各大影院，真实感扑面而来的大银幕体验不容错过。",
    ],
    date: "2026-10-13",
    author: "影讯编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=snow%20covered%20mountain%20peaks%20at%20dawn%20with%20deep%20blue%20shadows%20and%20warm%20orange%20sunrise%20light%2C%20epic%20editorial%20photography&width=800&height=600&seq=cinema-news-07&orientation=landscape",
    tags: ["幕后", "冒险", "实拍"],
  },
  {
    id: "n08",
    title: "11 月片单前瞻：犯罪悬疑与温情爱情双线开花",
    category: "资讯",
    summary:
      "随着 11 月临近，多部备受期待的新片陆续定档，犯罪悬疑与爱情题材将成为下月主线。",
    content: [
      "进入 11 月，电影市场将迎来新一轮新片潮。此前定档的犯罪悬疑片《暗夜行者》与温情爱情片《春日告白》都将在本月与观众见面。",
      "《暗夜行者》集结多位实力派演员，主打港式犯罪片的紧凑节奏与人性张力；《春日告白》则以细腻的日式青春叙事打动人心。",
      "无论是偏爱烧脑还是钟情治愈，11 月的片单都值得提前加入观影计划。",
    ],
    date: "2026-10-14",
    author: "影讯编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20marquee%20with%20glowing%20movie%20posters%20at%20night%2C%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20editorial%20photography&width=800&height=600&seq=cinema-news-08&orientation=landscape",
    tags: ["片单", "定档", "前瞻"],
  },
  {
    id: "n09",
    title: "影评｜《城市之光》：在失眠的城市里，彼此成为对方的光",
    category: "评论",
    summary:
      "一部关于孤独与治愈的都市剧情片，《城市之光》用克制的叙事讲了一个温暖的故事。",
    content: [
      "《城市之光》没有宏大的场面，却用一间深夜便利店、两个失眠的人，把都市人的孤独与温柔讲得恰到好处。",
      "影片最动人的地方在于克制。它不急于给出答案，而是让两个人在一个个凌晨的相遇中慢慢靠近，让观众自己体会那份“被看见”的珍贵。",
      "如果你也曾在深夜里感到疲惫，这部电影或许就是你此刻需要的一束光。",
    ],
    date: "2026-10-05",
    author: "特约影评人 · 林小满",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20glowing%20convenience%20store%20on%20a%20rainy%20city%20street%20at%20night%2C%20deep%20blue%20surroundings%20with%20orange%20light%20spill%2C%20editorial%20cinematography&width=800&height=600&seq=cinema-news-09&orientation=landscape",
    tags: ["影评", "剧情", "治愈"],
  },
];